import React, { memo } from "react";
import { makeStyles } from "@material-ui/styles";
import TextBox from "../../box/TextBox";
import styleConstants from "../../../styleConstants";
import BrazilOutlineIcon from "../../countryIcons/BrazilOutlineIcon";
import IndiaOutlineIcon from "../../countryIcons/IndiaOutlineIcon";

const useStyles = makeStyles({
  columnContainer: {
    display: "flex",
    justifyContent: "space-between"
  },
  columnDiv: {
    width: "45%",
    display: "flex",
    alignItems: "flex-start"
  },
  icon: {
    //height: '5rem',
    width: "120px",
    marginRight: "1rem",
    border: `2px ${styleConstants.colors.themeBlue} solid`,
    backgroundColor: styleConstants.colors.themeBluePale
  }
});

const CostVersusUsersCountryBox = props => {
  const classes = useStyles(props);

  return (
    <TextBox
      reference="Box 4.1"
      title="Costs versus Users at the Country Level"
      large={true}
    >
      <p>
        The countries with the most users are often not the countries with the
        largest consumption costs due to differences in method mix and
        differences in the unit prices paid for commodities. The clearest
        example of the disconnect between costs and users can be seen when
        contrasting India and Brazil:
      </p>
      <div className={classes.columnContainer}>
        <div className={classes.columnDiv}>
          <IndiaOutlineIcon width={120} height={120} className={classes.icon} />
          <p>
            <strong>India</strong> accounts for 30% of users across the 135
            LMICs but makes up only 7% of consumption costs: this is due to high
            levels of LAPM users in India, many of whom have low or no
            consumption cost associated with them.
          </p>
        </div>
        <div className={classes.columnDiv}>
          <BrazilOutlineIcon
            width={120}
            height={120}
            className={classes.icon}
          />
          <p>
            <strong>Brazil</strong> accounts for only 8% of users across the 135
            LMICs but makes up 30% of consumption costs: This is due to several
            factors, including a relatively large number of pill users in Brazil
            (14.3 million) and higher prices for commodities in Latin American
            countries.
          </p>
        </div>
      </div>
    </TextBox>
  );
};

export default memo(CostVersusUsersCountryBox);
